import config from '@/tenant/config.json'

type TenantConfig = {
    logo?: {
        dark_url?: string
        light_url?: string
    }
    description?: string
    favicon_url?: string
    color?: {
        light?: {
            primary?: string
        }
        dark?: {
            primary?: string
        }
    }
    name?: {
        title?: string
        copyright?: string
    }
    social?: {
        telegram_url?: string
        twitter_url?: string
        instagram_url?: string
        linkedin_url?: string
        youtube_url?: string
        email_url?: string
        contact_url?: string
        telegram_bot_url?: string
    }
}

export const tenantConfig = config as TenantConfig
